import './style.scss';

import React, { useEffect, useState } from 'react';
import {
  BuildersComponentsTrackingProvider,
  Link,
  Text
} from '@gjensidige/builders-components';
import { Phone } from '@gjensidige/builders-icons';
import { TrackingOptions } from '@gjensidige/core-analytics';
import { TrackingProvider } from '@gjensidige/core-analytics';

export interface WebshopNavigationProps {
  customerCareNumber: string;
  openHours: string;
  imageAlt: string;
  imageSrc: string;
  trackingObject?: { options: TrackingOptions };
}

export const WebshopNavigation: React.FC<WebshopNavigationProps> = (
  props: WebshopNavigationProps
) => {
  const { customerCareNumber, openHours, imageAlt, imageSrc } = props;

  const element = document.querySelector('body');
  const topMargin = () =>
    element?.style.marginTop
      ? parseInt(element?.style.marginTop) + 'px'
      : 0 + 'px';
  const [top, setTop] = useState(topMargin());
  useEffect(() => {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          setTop(topMargin());
        }
      });
    });

    element && observer.observe(element, { attributes: true });

    return () => observer.disconnect();
  }, []);

  const renderHeader = () => {
    return (
      <div className="sticky-head webshop-navigtion-component">
        <div className="webshop-header-container">
          <div className="icon-container">
            <div className="desktop-icon">
              <a href="/" className="logo-link">
                <img src={imageSrc} alt={imageAlt} className="logo-image" />
              </a>
            </div>
          </div>
          <div className="customer-info-container">
            <div className="customer-info">
              <Text size="body">
                <Phone className="phone-icon" focusable="false" />
                <Link
                  href={`tel:${customerCareNumber}`}
                  className="phone-number"
                >
                  {customerCareNumber}
                </Link>
              </Text>
              <Text size="body" className="open-hour">
                {openHours}
              </Text>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return props.trackingObject && props.trackingObject?.options ? (
    <BuildersComponentsTrackingProvider options={props.trackingObject?.options}>
      <TrackingProvider options={props.trackingObject?.options}>
        {renderHeader()}
      </TrackingProvider>
    </BuildersComponentsTrackingProvider>
  ) : (
    renderHeader()
  );
};
